import { withInstall } from '@vuesax-plus/utils'
import Checkbox from './src/checkbox.vue'

export const VsCheckbox = withInstall(Checkbox)
export default VsCheckbox

export * from './src/checkbox'
